import getSubscriptionStatus from "@helpers/getSubscriptionStatus"
import { getUserId } from "@helpers/sessionStorage"
import {
  setRevenueCatCustomerEmail,
  signInWithOAuth,
  signInWithPassword,
} from "@helpers/supabase"
import { redirect } from "react-router-dom"

export interface SignInActionData {
  error: string | null
}

export default async function signInAction({
  request,
}: {
  request: Request
}): Promise<SignInActionData | Response> {
  const formData = await request.formData()

  const email = formData.get("email") as string
  const password = formData.get("password") as string
  const provider = formData.get("provider") as "apple" | "google"

  const { error } = await signIn({ email, password, provider })

  if (error) {
    return { error: error.message }
  }

  await setRevenueCatCustomerEmail()

  const url = new URL(request.url)
  const searchParams = new URLSearchParams(url.search)
  const path = searchParams.get("path")

  if (path) {
    return redirect(path)
  }

  const userId = await getUserId()

  const subscriptionStatus = await getSubscriptionStatus(userId)

  switch (subscriptionStatus) {
    case "active": {
      return redirect("/account/subscription")
    }
    case "inactive": {
      return redirect("/checkout/plans")
    }
    case "none": {
      const url = new URL(request.url)
      const path = url.searchParams.get("path") ?? "/"

      return redirect(path)
    }
    default: {
      throw new Error(
        `Unhandled subscription status: ${subscriptionStatus as string}`,
      )
    }
  }
}

async function signIn({
  email,
  password,
  provider,
}: {
  email?: string
  password?: string
  provider?: "apple" | "google"
}) {
  if (provider) {
    const { data, error } = await signInWithOAuth({
      provider,
    })

    return { data, error }
  } else if (email && password) {
    const { data, error } = await signInWithPassword({
      email,
      password,
    })

    return { data, error }
  } else {
    throw new Error("No provider or email/password provided")
  }
}
